import { render, staticRenderFns } from "./iosother.vue?vue&type=template&id=53684c22&scoped=true&"
import script from "./iosother.vue?vue&type=script&lang=js&"
export * from "./iosother.vue?vue&type=script&lang=js&"
import style0 from "./iosother.vue?vue&type=style&index=0&id=53684c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53684c22",
  null
  
)

export default component.exports